import { formatDateTimeShort } from '../../lib/formatters'

/** The shared look for both rows: muted mono meta, dot-separated, one line where it fits. */
function TimestampRow({ parts }: { parts: string[] }) {
  return (
    // font-normal: the card's CardContent sets font-semibold, which a meta row must not inherit.
    <div className="text-muted-foreground flex flex-wrap gap-x-2 font-mono text-xs font-normal">
      {parts.map((part, index) => (
        <span key={part} className="whitespace-nowrap">
          {index > 0 && <span aria-hidden="true">· </span>}
          {part}
        </span>
      ))}
    </div>
  )
}

interface IndicationTimestampsProps {
  /** Null on a run that never posted — and on every row predating migration 0439, which did not backfill. */
  dateSubmitted: string | null | undefined
  dateCreated: string
  dateUpdated: string
}

/** Staff-only: when this carrier's application went out, and when the row last changed. */
export function IndicationTimestamps({ dateSubmitted, dateCreated, dateUpdated }: IndicationTimestampsProps) {
  return (
    <TimestampRow
      parts={[
        dateSubmitted
          ? `App sent ${formatDateTimeShort(dateSubmitted)}`
          : `No send date · started ${formatDateTimeShort(dateCreated)}`,
        `Updated ${formatDateTimeShort(dateUpdated)}`,
      ]}
    />
  )
}

/** Staff-only: when this quote row was made, which is not when the carrier answered —
 *  a manual quote is created PENDING and marked QUOTED later, and nothing records that
 *  moment. Nor is it the submit date: a quote inherits that from its indication. */
export function QuoteTimestamps({ dateCreated, dateUpdated }: { dateCreated: string; dateUpdated: string }) {
  return (
    <TimestampRow
      parts={[`Created ${formatDateTimeShort(dateCreated)}`, `Updated ${formatDateTimeShort(dateUpdated)}`]}
    />
  )
}
